import { useCallback } from 'react'
import { requests } from '../../../core/ajax'

export const useEEIICalls = () => {
  const { get } = requests

  const getEEII = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        get('/empresa_ca/tabla_empresas_instaladoras', config)
          .then((response) => {
            return resolve(response)
          })
          .catch(({ response }) => {
            return reject(response)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return {
    getEEII,
  }
}
